<template>
  <base-container ref="container">
    <a-card style="height: 100%;" ref="card">
      <a-row :gutter="[8, 0]" style="margin-bottom: 10px" ref="row">
        <a-col :span="4">
          <!-- 模板选择 -->
          <!-- <a-select v-model='mode' showSearch @change="changeMode" :defaultValue="0" option-label-prop="label"
            style="width: 100%;">
            <a-select-option v-for='(opt, idx) in modeList' :key='idx' :label="opt.name" :value='idx'>
              {{ opt.name }}
            </a-select-option>
          </a-select> -->
          <div style="text-align:center;margin-top: 10px;font-weight: 900;">设计组件</div>
        </a-col>
        <a-col :span="20">
          <a-space>
            <!-- 纸张设置 -->
            <a-button-group>
              <div v-for="(value, type) in paperTypes" :key="type">
                <a-button :type="curPaperType === type ? 'primary' : 'info'" @click="setPaper(type, value)">
                  {{ type }}
                </a-button>
              </div>
              <a-popover v-model="paperPopVisible" title="设置纸张宽高(mm)" trigger="click">
                <div slot="content">
                  <div style="display: flex;justify-content: space-around;">
                    <span>宽</span>
                    <span>高</span>
                  </div>
                  <a-input-group compact style="margin: 10px 10px">
                    <a-input type="number" v-model="paperWidth" style=" width: 100px; text-align: center"
                      placeholder="宽(mm)" />
                    <a-input style=" width: 30px; border-left: 0; pointer-events: none; backgroundColor: #fff"
                      placeholder="~" disabled />
                    <a-input type="number" v-model="paperHeight" style="width: 100px; text-align: center; border-left: 0"
                      placeholder="高(mm)" />
                  </a-input-group>
                  <a-button type="primary" style="width: 100%" @click="otherPaper">确定</a-button>
                </div>
                <a-button :type="'other' == curPaperType ? 'primary' : ''">自定义纸张</a-button>
              </a-popover>
            </a-button-group>
            <a-button type="text" icon="zoom-out" @click="changeScale(false)"></a-button>
            <a-input-number :value="scaleValue" :min="scaleMin" :max="scaleMax" :step="0.1" disabled style="width: 70px;"
              :formatter="value => `${(value * 100).toFixed(0)}%`" :parser="value => value.replace('%', '')" />
            <a-button type="text" icon="zoom-in" @click="changeScale(true)"></a-button>
            <!-- 预览/打印 -->
            <a-button-group>
              <a-button type="primary" icon="eye" @click="preView">
                预览
              </a-button>
              <a-button type="primary" @click="print">
                直接打印
                <a-icon type="printer" />
              </a-button>
            </a-button-group>
            <!-- 保存/清空 -->
            <a-button-group>
              <a-button type="primary" icon="save" @click="save">
                保存
              </a-button>
              <a-popconfirm title="是否确认清空?" okType="danger" okText="确定清空" @confirm="clearPaper">
                <a-icon slot="icon" type="question-circle-o" style="color: red" />
                <a-button type="danger">
                  清空
                  <a-icon type="close" />
                </a-button>
              </a-popconfirm>
            </a-button-group>
            <json-view :template="template" />
          </a-space>
        </a-col>
      </a-row>
      <a-row :gutter="[8, 0]">
        <a-col :span="4">
          <a-card style="height: 100vh">
            <a-row>
              <a-col :span="24" class="rect-printElement-types hiprintEpContainer">
              </a-col>
            </a-row>
          </a-card>
        </a-col>
        <a-col :span="14">
          <a-card class="card-design" :style="{ height: cardHeight + 'px' }">
            <div id="hiprint-printTemplate" class="hiprint-printTemplate"></div>
          </a-card>
        </a-col>
        <a-col :span="6" class="params_setting_container">
          <a-card>
            <a-row class="hinnn-layout-sider">
              <div id="PrintElementOptionSetting"></div>
            </a-row>
          </a-card>
        </a-col>
      </a-row>
      <!-- 预览 -->
      <print-preview ref="preView" />
    </a-card>

    <artisan-dialog ref="dialog" title="保存模板" :visible.sync="show" height="30%" width="40%" :isLoading="loading">
      <el-form :rules="rules" ref="selectForm" label-width="150px" size="mini" :model="dataForm">
        <el-row style="margin-top: 10px;">
          <el-col :span="12">
            <el-form-item prop="name" label="模板名称">
              <el-input clearable v-model="dataForm.name"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item prop="templateType" label="模板类型">
              <el-select v-model="dataForm.templateType" clearable placeholder="请选择">
                <el-option v-for="item in printTemplateTypes" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item prop="remark" label="模板描述">
              <el-input type="textarea" clearable v-model="dataForm.remark"></el-input>
            </el-form-item>
          </el-col>


        </el-row>
      </el-form>
      <template #footer>
        <el-button type="primary" size="mini" @click="saveConfirm">
          保存
        </el-button>
      </template>
    </artisan-dialog>
  </base-container>
</template>



<script>
import { save } from "@/api/print/print";
import printPreview from './preview'
import jsonView from '../json-view.vue'
import { loadEnums } from "@/api/sys/dicType";
import { hiprint } from '../../index'
import providers from './providers'
import printData from './print-data'

let hiprintTemplate;
export default {
  name: "printCustom",
  components: { printPreview, jsonView },
  data() {
    return {
      cardHeight: undefined,
      dataForm: {
        name: "",
        remark: "",
        jsonString: "",
        deptId: "",
      },
      printTemplateTypes: [],
      rules: {
        name: [
          { required: true, message: '请输入模板名称', trigger: 'blur' },
        ],
        templateType: [
          { required: true, message: '请选择打印类型', trigger: 'change' },
        ],
      },
      show: false,
      loading: false,
      template: null,
      // 模板选择
      mode: 0,
      modeList: [],
      // 当前纸张
      curPaper: {
        type: 'other',
        width: 80,
        height: 80
      },
      // 纸张类型
      paperTypes: {
        'A3': {
          width: 420,
          height: 296.6
        },
        'A4': {
          width: 210,
          height: 296.6
        },
        'A5': {
          width: 210,
          height: 147.6
        },
        'B3': {
          width: 500,
          height: 352.6
        },
        'B4': {
          width: 250,
          height: 352.6
        },
        'B5': {
          width: 250,
          height: 175.6
        }
      },
      scaleValue: 1,
      scaleMax: 5,
      scaleMin: 0.5,
      // 自定义纸张
      paperPopVisible: false,
      paperWidth: '80',
      paperHeight: '80',
      lastjson: '',
    }
  },
  computed: {
    curPaperType() {
      let type = 'other'
      let types = this.paperTypes
      for (const key in types) {
        let item = types[key]
        let { width, height } = this.curPaper
        if (item.width === width && item.height === height) {
          type = key
        }
      }
      return type
    }
  },
  created() {
    loadEnums("PrintTemplateTypeOption").then((res) => {
      this.printTemplateTypes = res.data.data.PrintTemplateTypeOption;
    });
  },
  mounted() {
    this.cardHeight = this.$refs.card.$el.clientHeight - (this.$refs.row.$el.clientHeight * 10);
    this.init()
    this.otherPaper()
  },
  methods: {
    saveConfirm() {
      this.$refs.selectForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          let printData = {};
          if (hiprintTemplate.getJson().panels[0].printElements) {
            hiprintTemplate.getJson().panels[0].printElements.forEach((e) => {
              if (e.options.field) {
                printData[e.options.field] = e.options.testData
              }
            })
          }
          this.dataForm.printDataString = JSON.stringify(printData)
          this.dataForm.jsonString = JSON.stringify(hiprintTemplate.getJson())
          save(this.dataForm).then((res) => {

            this.loading = false;
            this.show = false;
            this.$message({
              type: "success",
              message: "保存成功！",
            });
          }).catch(() => {
            this.loading = false;
          })
        }
      });
    },
    init() {
      this.modeList = providers.map((e) => {
        return { type: e.type, name: e.name, value: e.value }
      })
      this.changeMode()
    },
    changeMode() {
      let { mode } = this
      let provider = providers[mode]
      hiprint.init({
        providers: [provider.f]
      });
      $('.hiprintEpContainer').empty()
      hiprint.PrintElementTypeManager.build('.hiprintEpContainer', provider.value);
      $('#hiprint-printTemplate').empty()
      let templates = this.$ls.get('KEY_TEMPLATES', {})
      let template = templates[provider.value] ? templates[provider.value] : {}
      this.template = hiprintTemplate = new hiprint.PrintTemplate({
        template: template,
        dataMode: 1, // 1:getJson 其他：getJsonTid 默认1
        history: false, // 是否需要 撤销重做功能
        onDataChanged: (type, json) => {
          // 更新模板
          // hiprintTemplate.update(json)
        },
        settingContainer: '#PrintElementOptionSetting',
        paginationContainer: '.hiprint-printPagination'
      });
      hiprintTemplate.design('#hiprint-printTemplate');
      // 获取当前放大比例, 当zoom时传true 才会有
      this.scaleValue = hiprintTemplate.editingPanel.scale || 1;
    },
    /**
     * 设置纸张大小
     * @param type [A3, A4, A5, B3, B4, B5, other]
     * @param value {width,height} mm
     */
    setPaper(type, value) {
      try {
        if (Object.keys(this.paperTypes).includes(type)) {
          this.curPaper = { type: type, width: value.width, height: value.height }
          hiprintTemplate.setPaper(value.width, value.height)
        } else {
          this.curPaper = { type: 'other', width: value.width, height: value.height }
          hiprintTemplate.setPaper(value.width, value.height)
        }
      } catch (error) {
        this.$message.error(`操作失败: ${error}`)
      }
    },
    changeScale(big) {
      let scaleValue = this.scaleValue;
      if (big) {
        scaleValue += 0.1;
        if (scaleValue > this.scaleMax) scaleValue = 5;
      } else {
        scaleValue -= 0.1;
        if (scaleValue < this.scaleMin) scaleValue = 0.5;
      }
      if (hiprintTemplate) {
        // scaleValue: 放大缩小值, false: 不保存(不传也一样), 如果传 true, 打印时也会放大
        hiprintTemplate.zoom(scaleValue, true);
        this.scaleValue = scaleValue;
      }
    },
    otherPaper() {
      let value = {}
      value.width = this.paperWidth
      value.height = this.paperHeight
      this.paperPopVisible = false
      this.setPaper('other', value)
    },
    preView() {
      let { width } = this.curPaper
      this.$refs.preView.show(hiprintTemplate, printData, width)
    },
    print() {
      if (window.hiwebSocket.opened) {
        const printerList = hiprintTemplate.getPrinterList();
        hiprintTemplate.print2(printData, { printer: '', title: 'hiprint测试打印' });
        return
      }
      this.$message.error('客户端未连接,无法直接打印')
    },
    save() {
      this.show = true
      this.dataForm = {
        name: "",
        remark: "",
        jsonString: "",
        deptId: "",
      },
        this.$refs.selectForm.resetFields();
      //  let { mode } = this
      //   let provider = providers[mode]
      // this.setTemplate({
      //   name: provider.value,
      //   json: hiprintTemplate.getJson()
      // })
    },
    setTemplate(payload) {
      let templates = this.$ls.get('KEY_TEMPLATES', {})
      templates[payload.name] = payload.json
      this.$ls.set('KEY_TEMPLATES', templates)
      this.$message.info('保存成功')
    },
    clearPaper() {
      try {
        hiprintTemplate.clear();
      } catch (error) {
        this.$message.error(`操作失败: ${error}`);
      }
    }
  }
}
</script>

<style lang="less" scoped>
// build 拖拽
/deep/ .hiprint-printElement-type>li>ul>li>a {
  padding: 4px 4px;
  color: #1296db;
  line-height: 1;
  height: auto;
  text-overflow: ellipsis;
}

// 默认图片
/deep/ .hiprint-printElement-image-content {
  img {
    content: url("~@/views/print/assets/logo.png");
  }
}

// 设计容器
.card-design {
  overflow: hidden;
  overflow-x: auto;
  overflow-y: auto;
}

.base-container {
  overflow: hidden;
}
</style>
